import { PublicKey } from "@solana/web3.js";
import React, { FC, useEffect, useState } from "react";
import { ITreasuryTokenAccInfo } from "../../../common/interfaces/clubs.interface";
import WizardField from "../../WizardField/WizardField";
import WizardHeader from "../WizardHeader/WizardHeader";
import { TokenListProvider } from "@solana/spl-token-registry";
import {
  ICreateClubWizardForm,
  ICreateClubWizardProps,
} from "../../../common/interfaces/clubs-wizard.interface";
import { useFormikContext } from "formik";
import "./TreasuryConfiguration.scss";
import { NATIVE_MINT } from "@solana/spl-token";
import { mint, usdcMint, usdtMint } from "../../../solana/common/utilities";

const TreasuryConfiguration: FC<{
  form: ICreateClubWizardProps;
}> = ({ form }) => {
  const { setFieldValue, values } = useFormikContext<ICreateClubWizardForm>();
  const [availableTokensList, setAvailableTokenList] =
    useState<ITreasuryTokenAccInfo[]>();
  const [isFundraiseConfigVisible, toggleIsFundraiseConfigVisible] = useState(
    !values.skipFundraise
  );
  useEffect(() => {
    void getAllMintsInfo();
  }, []);
  const getAllMintsInfo = async () => {
    const availableToken: ITreasuryTokenAccInfo[] = [];
    const tokens = await new TokenListProvider().resolve();
    //TODO@milica-gilder: add mainnet filter before deploy
    const tokenList = tokens
      .getList()
      .filter((item) => item.logoURI !== undefined)
      .sort((a, b) => a.name.localeCompare(b.name));

    const solToken = tokenList.find(
      (item) => item.address === NATIVE_MINT.toString()
    );
    const usdcToken = tokenList.find(
      (item) => item.address === usdcMint.toString()
    );
    const unqToken = tokenList.find((item) => item.address === mint.toString());
    const usdtToken = tokenList.find(
      (item) => item.address === usdtMint.toString()
    );
    solToken &&
      availableToken.push({
        balance: 0,
        decimals: solToken.decimals,
        image: solToken.logoURI!,
        mint: new PublicKey(solToken.address),
        name: "Solana",
        symbol: solToken.symbol,
        tokenAddress: undefined,
        profit: 0,
      });

    usdcToken &&
      availableToken.push({
        balance: 0,
        decimals: usdcToken.decimals,
        image: usdcToken.logoURI!,
        mint: new PublicKey(usdcToken.address),
        name: usdcToken.name,
        symbol: usdcToken.symbol,
        tokenAddress: undefined,
        profit: 0,
      });

    unqToken &&
      availableToken.push({
        balance: 0,
        decimals: unqToken.decimals,
        image: unqToken.logoURI!,
        mint: new PublicKey(unqToken.address),
        name: unqToken.name,
        symbol: unqToken.symbol,
        tokenAddress: undefined,
        profit: 0,
      });

    usdtToken &&
      availableToken.push({
        balance: 0,
        decimals: usdtToken.decimals,
        image: usdtToken.logoURI!,
        mint: new PublicKey(usdtToken.address),
        name: "Tether",
        symbol: usdtToken.symbol,
        tokenAddress: undefined,
        profit: 0,
      });

    tokenList.forEach(
      (item) =>
        item.address !== solToken?.address &&
        item.address !== unqToken?.address &&
        item.address !== usdcToken?.address &&
        item.address !== usdtToken?.address &&
        availableToken.push({
          balance: 0,
          decimals: item.decimals,
          image: item.logoURI!,
          mint: new PublicKey(item.address),
          name: item.name,
          symbol: item.symbol,
          tokenAddress: undefined,
          profit: 0,
        })
    );
    setAvailableTokenList(availableToken);
  };

  return (
    <div className="treasury-configuration">
      <WizardHeader description="The Club can have Main and Other currencies. Here you configure which currency will be the Main Currency for your Club. The Main Currency is the currency in which Fundraise is done. Once chosen, the Main Currency for the Club cannot be changed. Main and Other currencies can be used for trade and withdrawal. Staking can be done only in UNQ." />
      {availableTokensList && (
        <div className="treasury-configuration__currency">
          <WizardField
            type="mint-select"
            name="Currency"
            label="Currency"
            placeholder=""
            mintSelectItems={availableTokensList}
            isFundraisingConfig
            required
            chosenMint={values.mint.toString()}
          />
        </div>
      )}
    </div>
  );
};

export default TreasuryConfiguration;
